import type { Spacings } from '@rulebooks/evidend-titan';
import { spacing } from '@rulebooks/evidend-titan';
import styled, { css } from 'styled-components';

interface IColumns {
  /* The number of columns. */
  count?: number;
  /* Alternative template. */
  template?: string;
  /* The spacing between columns. */
  gap?: Spacings;
  /* The spacing between rows. */
  rowGap?: Spacings;
  /* The spacing below the columns. */
  spaceAfter?: Spacings;
}

export const Columns = styled.div<IColumns>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.template || `repeat(${props.count ?? 1}, minmax(0, 1fr))`};
  align-items: start;

  ${(props) =>
    (props.gap ?? 4) &&
    css`
      column-gap: ${spacing(props.gap ?? 4)};
    `}

  ${(props) =>
    props.rowGap &&
    css`
      row-gap: ${spacing(props.rowGap)};
    `}

  ${(props) =>
    props.spaceAfter &&
    css`
      margin-bottom: ${spacing(props.spaceAfter)};
    `}
`;
